import { render, staticRenderFns } from "./FormList.vue?vue&type=template&id=56bf73b2&scoped=true&"
import script from "./FormList.vue?vue&type=script&lang=js&"
export * from "./FormList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bf73b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56bf73b2')) {
      api.createRecord('56bf73b2', component.options)
    } else {
      api.reload('56bf73b2', component.options)
    }
    module.hot.accept("./FormList.vue?vue&type=template&id=56bf73b2&scoped=true&", function () {
      api.rerender('56bf73b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/form/FormList.vue"
export default component.exports